import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './datasets-create-fields.hbs'
import rowTemplate from './datasets-create-fields-row.hbs'
import primaryKey from './datasets-create-fields-primary-key.hbs'
import FormView from 'scoreboard/components/form-view'
import dataTypes from './data-types'
import dropdown from 'scoreboard/components/dropdown'
import selects from 'scoreboard/components/selects'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import ToggleAllCheckboxes from 'scoreboard/components/toggle-all-checkboxes'
import formHelper from 'scoreboard/components/form-helper'
import calendars from 'scoreboard/components/calendars'
import i18n from 'scoreboard/components/i18n'
import { SCHEDULE } from 'scoreboard/imports/label-owners-schedule'
import GetValidPrimaryKeyFields from './get-valid-primary-key-fields'
const { getValidPrimaryKeyAutomaticFields } = GetValidPrimaryKeyFields
import isGeographicOrRollup from '../is-geographic-or-rollup'

import DataType from 'scoreboard/datasets/model/data-type'
const { NUMBER, PERCENT, CURRENCY, TEXT, DATE, TIME, DATE_TIME, CALENDAR_PERIOD, DATASET_LINK, COUNTRY, YES_NO,  } = DataType;

const TOTAL_PER_LOAD = 100
// When the user scrolls within this many pixels of the bottom of the dialog,
// we'll load more rows
const LAZYLOAD_SCROLL_THRESHOLD = 400

// for each data type detected, lists the allowed data types the user can choose
// to use instead for the field
function allowedChanges(dataType) {
	switch (dataType) {
		case NUMBER: case PERCENT: case CURRENCY:
			return [ NUMBER, PERCENT, CURRENCY, TEXT ]
		case COUNTRY:
			return [COUNTRY, NUMBER]
		case DATE_TIME:
			return [ DATE_TIME, TEXT, DATE, TIME ]
		case TEXT:
			return [ TEXT ]
		case YES_NO:
			// #55823 Add option to set field with 0/1 entries as Number
			return [ YES_NO, TEXT, NUMBER ]

		// #24809 if the column was blank, the user can choose whatever dataType
		// they want
		case null: case undefined:
			return _.map(dataTypes, 'id')
		default:
			return [ dataType , TEXT ]
	}
}

const DatasetsCreateFields = Backbone.View.extend({

	tagName: 'form',

	className: 'datasets-create-fields',

	events: {
		'change [type=checkbox]': 'onChangeCheckbox'
	},

	/** @type {Dataset} */
	model: null,

	/**
	 * The last step of the Create Dataset wizard, where the user is presented with
	 * a bunch of automatically generated fields.
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model the dataset
	 *
	 * @param {DatasetsWizard} options.wizard the wizard
	 */
	initialize: function(options) {
		this.options = options || {}
		this.existingFields = []
		// if we're adding a data source to a dataset, then we need to bring in the
		// fields it already had before starting this step
		if (this.options.wizard && this.options.wizard.startedWithNoDataSource) {
			this.existingFields = this.model.get('fields')
		}
		var MyFormView = FormView.extend({
			test: () => this.test()
		})
		this.formView = new MyFormView({
			el: this.el,
			submit: this.submit.bind(this),
			allowCleanSubmission: true,
			guard: false
		})
	},

	render: function() {
		let connectionLabel = this.model.get('dataSourceMetadata').label
		this.$el.empty().append(template({ connectionLabel }))

		this.options.wizard.render({
			formView: this.formView,
			stateSaver: this.saveState.bind(this)
		})

		// must be after this.options.wizard.render
		this.$('.dialog-footer').prepend(primaryKey())

		this.renderTable()
		this.renderSelects()

		this.toggleAllCheckboxes = new ToggleAllCheckboxes({
			el: this.el
		}).render()

		this.formView.start()

		return this
	},

	/**
	 * Renders the table and everything inside it.  Useful when changing
	 * worksheets
	 */
	renderTable: function() {
		_.invokeMap(this.markedFields, 'remove')
		this.markedFields = []
		// We will initially only load a specified amount (TOTAL_PER_LOAD) of
		// rows and then lazy load more as the user scrolls down.
		// Store the number of rows that have been rendered so far
		this.renderedRowsTotal = 0
		this.previouslyRenderedRowsTotal = 0
		this.renderRows()
		this.renderFieldNames()
		this.renderDataTypes()

		// Function to check if the scroll position is near
		// the bottom of a scrollable element.
		function isNearBottom(element) {
			const elementHeight = element.clientHeight
			const scrollTop = element.scrollTop
			const scrollHeight = element.scrollHeight

			return scrollHeight - (elementHeight + scrollTop) < LAZYLOAD_SCROLL_THRESHOLD
		}

		const scrollableElement = this.$('.dialog-body')[0]

		// Event listener for scroll events on the scrollable element
		scrollableElement.addEventListener('scroll', () => {
			if (isNearBottom(scrollableElement)) {
				this.renderRows()
				this.renderFieldNames()
				this.renderDataTypes()
			}
		})
	},

	renderRows: function() {
		let html = ''
		const metadata = this.model.get('dataSourceMetadata')
		let renderedNowTotal = 0
		this.previouslyRenderedRowsTotal = this.renderedRowsTotal
		_.each(metadata.fields, (field, index) => {
			if (index >= this.renderedRowsTotal &&
				renderedNowTotal < TOTAL_PER_LOAD) {
				// Increment this.renderedRowsTotal within the loop
				this.renderedRowsTotal++

				// #30688 if the first row is ignored, find the first
				// non-ignored row for the example
				html += rowTemplate(field)

				renderedNowTotal++
			}
		})
		this.$('tbody').append(html)
	},

	renderFieldNames: function() {
		// field names are required
		_.each(this.$('input[type=text]'), (el) => {
			// #53900 w/ lazy loading, we need to make sure we are only marking
			// new fields. if there is already a marked field present on this
			// input, don't add another
			if (!this.$(el).parent().hasClass('marked-field')) {
				this.markedFields.push(new MarkedField({
					el: el,
					validator: (val) => {
						if (!this.$(el).closest('tr').hasClass('is-disabled')) {
							return requiredValidator(val)
						}
					}
				}).render())
			}
		})
	},

	renderDataTypes: function() {
		// To keep the user experience simple, don't allow rollups or dataset-links
		let withoutRollupOrDatasetLinks = _.filter(dataTypes, dt =>
			dt.id != DATASET_LINK && !isGeographicOrRollup(dt.id))
		// determine if this dataset has any records after the header row
		let hasRecords = true
		let rows = _.get(this.model.attributes, 'preview.rows', [])
		let headerRowIndex = this.model.headerRowIndex()
		if (rows.length - 1 <= headerRowIndex) {
			hasRecords = false
		}
		_.each(this.$('select.data-type'), (el, index) => {
			// Don't re-render selects if they've already been loaded
			if (index >= this.previouslyRenderedRowsTotal) {
				this.$(el).empty()
				let dataType = this.model.get('dataSourceMetadata').fields[index].dataType
				let options = withoutRollupOrDatasetLinks
				// #45830 only limit allowed data types if there are records present
				if (this.model.isSpreadsheet() && hasRecords) {
					options = _.filter(options, (option) => {
						return _.indexOf(allowedChanges(dataType), option.id) != -1
					})
				}
				dropdown.idLabels(el, options, dataType)
			}
		})
	},

	/**
	 * Renders the worksheet and primary key dropdowns.
	 *
	 * Toggles the worksheet and primary key dropdowns based on whether they
	 * required.  Worksheets are only for Excel workbooks, and primary keys
	 * are only for databases.
	 */
	renderSelects: function() {
		let hasSelected

		const metadata = this.model.get('dataSourceMetadata')
		let options = _(getValidPrimaryKeyAutomaticFields(metadata.fields))
			.orderBy(field => field.label.toLocaleUpperCase())
			.map(field => {
				let option = { value: field.label, label: _.escape(field.label) }
				if (field.label === metadata.primaryKey) {
					option.selected = true
					hasSelected = true
				}
				return option
			})
			.value()
		options = [{
			value: '',
			label:
				`<span class="blank-value">
					${i18n.get('datasets.dataSource.choosePrimaryKey.none')}
				</span>`,
			selected: !hasSelected
		}].concat(options)
		selects.filtering(this.$('[name=primaryKey]'), {
			options,
			sort: [],
			escapeLabels: false
		})
		this.markedFields.push(new MarkedField({
			el: this.$('[name=primaryKey]'),
			// #29753 primary key is required with databases but is only
			// an option with spreadsheets
			validator: this.model.isRecordIdOptional() ? null : requiredValidator
		}).render())
	},

	onChangeCheckbox: function(e) {
		// let ToggleAllCheckboxes do its work first
		process.nextTick(() => {
			// whenever a checkbox changes state, toggle the `is-disabled` class
			// appropriately for all checkbox.  This neatly handles the first
			// "Toggle All" checkbox in the header row and all the other rows with
			// minimal code
			_.each(this.$('tbody tr'), (rowEl) => {
				var checked = this.$(rowEl).find('[type=checkbox]').prop('checked')
				this.$(rowEl).toggleClass('is-disabled', !checked)
					.find('[type=text], select')
					.prop('disabled', !checked)
				// redraw the select to get correct enabled/disabled state
				selects(this.$(rowEl).find('select'))
				let markedField = this.$(rowEl).find('.marked-field').data('view')
				if (checked) {
					markedField.validate()
				} else {
					markedField.clearError()
				}
			})
			this.formView.change()
		})
	},

	test: function() {
		const formFields = this.getFields()

		// adapted from form-helper.js:test, but also takes into account
		// disabled rows
		var errors = _.transform(this.getMarkedFields(), function(result, field) {
			if (field && field.test()) {
				result.push(field)
			}
		}, [])

		if (!_.isEmpty(errors)) {
			return errors
		}

		const primaryKey = this.$('[name=primaryKey]').val()
		const pkNotSelected = _.isEmpty(primaryKey)

		// spreadsheets are allowed to not have a PK set at this point
		if (this.model.isSpreadsheet() && pkNotSelected) {
			return
		}

		const row = this.$('[data-name="' + _.escape(primaryKey) + '"]')
		const pkFieldIsDisabled = row.hasClass('is-disabled')
		// #38494 don't let the user ignore the column that they've selected as the PK
		if (pkFieldIsDisabled) {
			return i18n.get('datasets.connection.primaryKey.cantIgnore')
		}

		return DatasetsCreateFields.testUniqueFieldNames(formFields)
	},

	getFields: function() {
		const metadata = this.model.get('dataSourceMetadata')
		const rows = this.$('tbody tr')
		const unrenderedFields = metadata.fields.slice(this.renderedRowsTotal)
		const checkedFields = _.map(rows, row => {
			const fromDom = formHelper.readFromDom(row)
			const intermediateColumnName = $(row).data('intermediate-column-name')
			const automaticField = metadata.automaticFieldsByIntermediateColumn[intermediateColumnName]
			return _.extend({}, automaticField, fromDom)
		})
		// If fields haven't been lazy loaded yet, include those by default
		let allFields = _.concat(checkedFields, unrenderedFields)
		_.each(allFields, field => {
			const automaticField = this.getAutomaticFieldForUserEditedField(field)
			if (automaticField.label === this.$('[name=primaryKey]').val()) {
				field.primaryKey = true
			}

			const equationColumn = this.getEquationColumn(field)
			field.equation = `[${equationColumn}]`

			if (field.dataType === NUMBER || field.dataType === CURRENCY) {
				field.aggregationType = 'sum'
			}
			if (field.dataType === PERCENT) {
				field.aggregationType = 'average'
			}
			if (_.includes([DATE, DATE_TIME, CALENDAR_PERIOD], field.dataType)) {
				// use the default calendar for the overall system
				field.defaultCalendarId = _.get(calendars.calendars, '0.id')
			}
		})
		allFields = _.filter(allFields, (field, index) => {
			return !this.$(rows[index]).hasClass('is-disabled')
		})
		allFields = _.concat(allFields, this.existingFields)

		return allFields
	},

	getAutomaticFieldForUserEditedField: function(userEditedField) {
		const metadata = this.model.get('dataSourceMetadata')
		return metadata.automaticFieldsByIntermediateColumn[userEditedField.intermediateColumnName]
	},

	getEquationColumn: function(field) {
		this.saveState()
		const metadata = this.model.get('dataSourceMetadata')
		const automaticFieldsByRawColumn = _.keyBy(metadata.fields, 'rawColumnName')
		const automaticField = automaticFieldsByRawColumn[field.rawColumnName]
		return automaticField?.intermediateColumnName
	},

	validate: function() {
		// adapted from form-helper.js:validate, but also takes into account
		// disabled rows
		var fields = this.getMarkedFields()
		var answer = _.compact(_.invokeMap(fields, 'validate'))
		if (!_.isEmpty(answer)) {
			return answer
		}

		return this.test()
	},

	getMarkedFields: function() {
		// adapted from form-helper.js:getMarkedFields, but also takes into account
		// disabled rows
		return _(this.$el.find('.marked-field:visible'))
			.filter((el) => {
				return !this.$(el).closest('tr').hasClass('is-disabled')
			})
			.map((el) => {
				// need to grab the first one because the rich selects put a hidden
				// input in the DOM after the select
				return $(el).find('input, select, textarea').first().data('view')
			})
			.value()
	},

	saveState: function() {
		const metadata = this.model.get('dataSourceMetadata')
		if (this.model.isSpreadsheet()) {
			// #31019 set the columns to the row that the user selected as the header row
			// so that will be what the intermediate table uses as its column names
			metadata.columns = _.map(metadata.fields, 'label')
		}

		const primaryKeyLabel = this.$('[name=primaryKey]').val()
		const fieldsByLabel = _.keyBy(metadata.fields, 'label')
		const primaryKeyField = fieldsByLabel[primaryKeyLabel]
		metadata.primaryKey = primaryKeyField?.intermediateColumnName

		this.model.set('dataSourceMetadata', metadata)
	},

	submit: function() {
		this.saveState()
		const fields = this.getFields()

		$.post({
			url: this.model.getValidatePrimaryKeyUrl(),
			data: JSON.stringify(this.model),
			success: () => {
				if (this.options.wizard.isLastStep()) {
					return this.model.save({ fields }, {
						success: model => {
							this.trigger('done', model)
							this.options.wizard.finish(model)
						},
						error: (model, response) => this.formView.error(response)
					})
				} else {
					this.model.set({ fields })
					this.options.wizard.options.mode = SCHEDULE
					this.options.wizard.next()
				}
			},
			error: (xhr) => {
				this.formView.error(xhr)
			}
		})
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.toggleAllCheckboxes], 'remove')
		_.invokeMap(this.markedFields, 'remove')
	}

}, {

	/** Ensures field names are unique */
	testUniqueFieldNames: function(fields) {
		const uniqueLabelFields = _.uniqBy(fields, field => field?.label?.toLowerCase())
		if (fields.length !== uniqueLabelFields.length) {
			return i18n.get('datasets.fields.error.labelsMustBeUnique')
		}
	}

})

export default DatasetsCreateFields

DatasetsCreateFields.__filename__ = 'datasets/edit/datasets-create-fields.js'
